import { render } from "./InfosProduit.vue?vue&type=template&id=a39289e8"
import script from "./InfosProduit.vue?vue&type=script&lang=js"
export * from "./InfosProduit.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__